"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagIN = function FlagIN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#fab446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,50.14a38,38,0,1,1,38-38,38,38,0,0,1-38,38Zm0-68.86a30.9,30.9,0,1,0,30.9,30.9,30.93,30.93,0,0,0-30.9-30.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.1,12.18a4.3,4.3,0,1,1-4.3-4.3,4.3,4.3,0,0,1,4.3,4.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,12.82.86,13.93l-23.49-1.11V11.54L.86,10.43,11.8,11.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,12.82l10.93,1.11,23.5-1.11V11.54l-23.5-1.11L11.8,11.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.16,12.18,10.05,1.24l1.11-23.49h1.28L13.55,1.24,12.44,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.16,12.18,10.05,23.12l1.11,23.49h1.28l1.11-23.49L12.44,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.34,12.64l-8.51-7L-13-11.71l.91-.91L5.3,3.21l7,8.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.34,12.64l7,8.51L35.69,37l.91-.91L20.77,18.68l-8.51-7Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.34,11.72l7-8.51L35.69-12.62l.91.91L20.77,5.68l-8.51,7Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.34,11.72l-8.51,7L-13,36.07l.91.91L5.3,21.15l7-8.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.05,12.78,2.37,18l-22.13,8-.49-1.19L1,14.75l10.52-3.17Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.05,12.78,22.57,9.61,43.85-.4l-.49-1.19-22.13,8-9.68,5.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2,12.43,6,2.75-2-19.38l1.19-.5,10,21.29L12.4,11.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2,12.43,14.37,23l10,21.28,1.19-.49-8-22.13-5.2-9.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.55,12.78,1,9.61-20.25-.4l.49-1.19,22.13,8,9.68,5.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.55,12.78,21.23,18l22.13,8,.49-1.19-21.28-10L12.05,11.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2,11.93,14.37,1.41l10-21.29,1.19.5-8,22.13-5.2,9.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2,11.93,6,21.61-2,43.74l1.19.49L9.23,23,12.4,12.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.6,12.18a5.8,5.8,0,1,1-5.8-5.8,5.79,5.79,0,0,1,5.8,5.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.28,12.18A3.48,3.48,0,1,1,11.8,8.7a3.48,3.48,0,0,1,3.48,3.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagIN;
exports["default"] = _default;